import React from "react";
import { Card, CardTitle, Row, Button, Col } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getFormatedDate, getTimeFormat } from "../../../services/commonFunction";

const RemarkHistory = () => {
    const session = useSelector((state) => state.session);
    const navigate = useNavigate();
    let changesLogData = session.changesLogData?.data || [];
    let redirectUrl = session.changesLogData?.redirect;
    const hasData = [changesLogData].some(
        (data) =>
            Array.isArray(data)
                ? data.length > 0
                : data && typeof data === "object"
                    ? Object.keys(data).length > 0
                    : false
    );
    const normalizedReminderData = Array.isArray(changesLogData)
        ? changesLogData.flatMap((entry, entryIndex) =>
            (entry.remark || []).map((item, index) => {
                const dateObj = new Date(item.created_at);

                return {
                    srNo: entryIndex + 1 + "-" + (index + 1),
                    date: dateObj, // DD/MM/YYYY
                    time: dateObj, // HH:mm:ss
                    createdBy: item.created_by_name?.trim(),
                    remark: item.remark?.replace(/<[^>]*>/g, ""), // remove HTML tags
                };
            })
        )
        : [];
    return (
        <Row>
            <Col>
                <Card>
                    <CardTitle tag="h5" className="history_title">
                        <div>
                            LMS <i className="bi bi-chevron-right card-title-icon"></i>{" "}
                            <i className="bi bi-chevron-right card-title-icon"></i> History
                        </div>
                    </CardTitle>

                    <div className="historyContainer">
                        {hasData ? (
                            <Row className="autoWidthImportant sampleverification-table module-log-history">
                                <>
                                    <div className="renderList_table_heading my-2">
                                        <h2>Outstanding Remark History</h2>
                                    </div>

                                    <table className="table table-sm table-white borderless align-middle renderTable">
                                        <thead>
                                            <tr>
                                                <th className="text-center">Sr. No</th>
                                                <th>Date</th>
                                                <th>Time</th>
                                                <th>Created By</th>
                                                <th>Remark</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {normalizedReminderData.map((row, index) => (
                                                <tr key={index}>
                                                    <td className="text-center">{index + 1}</td>
                                                    <td>{getFormatedDate(row.date,1)}</td>
                                                    <td>{getTimeFormat(row.date)}</td>
                                                    <td>{row.createdBy}</td>
                                                    <td>{row.remark}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </>
                            </Row>
                        ) : (
                            <div className="historyContainerItemBox">
                                <p>No History Found</p>
                            </div>
                        )}
                    </div>
                </Card>

                <div className="submit_btns">
                    <Button
                        className="saveBtn"
                        id="submit_btn3"
                        onClick={() => navigate(redirectUrl || -1)}
                    >
                        Back To List
                    </Button>
                </div>
            </Col>
        </Row>
    );
};

export default RemarkHistory;
